import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { GetSubscriptionResponse } from '@upright/common/subscription/api-types';
import { fetchOrThrow } from '@upright/ui/api/common/fetchers/fetch-or-throw';
import { useGetLoggedInUser } from '@upright/ui/common/generic/hooks';

type UseGetActiveSubscriptionOptions = {
  enabled?: boolean;
};

/**
 * Hook to get the active subscription of the current user.
 */
export const useGetActiveSubscription = (
  options?: UseGetActiveSubscriptionOptions,
): UseQueryResult<GetSubscriptionResponse, Error> => {
  const user = useGetLoggedInUser();
  const enabled = options?.enabled ?? true;

  return useQuery<GetSubscriptionResponse>({
    queryKey: ['get-active-subscription', user?.id],
    queryFn: async () => {
      return await fetchOrThrow<GetSubscriptionResponse>(`/subscription`, 'GET');
    },
    enabled: !!user && enabled,
  });
};
